import {useEffect, useRef} from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

export const DiagnosesLogic = (sectionName, noteName="", diagnoseName = "", clearForm, deactivateFunc ) => {
    const {setValue, control} = useFormContext()
    // Active follows the live form value so the section enables itself when
    // the form gets prefilled (see PatientDrugsInpLogic).
    const toggle = useWatch({control: control, name: sectionName})
    const active = deactivateFunc ? !!toggle : true
    const wasOn = useRef(!!toggle)

    // Clear this section's own fields ONLY when the user switches it off
    // (on -> off). Never on mount / during prefill, and never reset the
    // whole form.
    useEffect (() => {
        if (wasOn.current && !toggle) {
            clearFormValues()
        }
        wasOn.current = !!toggle
    }, [toggle])

    const clearFormValues = () => {
        setValue(diagnoseName, [
            {
                label: "Vyhledejte...", value: "",
                drugs: [{label: "Vyhledejte...", value: ""}]
            }
        ])
        setValue(noteName, "")
    }

    const toggleSection = () => {
        clearForm(active)
    }

    return {state: {active}, toggleSection}
}
